
















































import Component, {mixins} from 'vue-class-component';
import GoogleMapsLoader from '../../mixins/GoogleMapsLoader';
import CurrentLocation from '../../mixins/CurrentLocation';
import {Provide, Watch, Prop} from 'vue-property-decorator';
import {} from 'googlemaps';
import UserMarker from '../common/UserMarker.vue';
import {State, Action, Mutation, namespace} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {mapDashboard, MarkerInjectable} from '@/components/common/types';
import {PositionObfuscator} from '@/store/User/types';
import firebase from 'firebase/app';
import GeoPoint = firebase.firestore.GeoPoint;
import moment from 'moment';
import {DateTime} from 'luxon';
// import { Constants, Location, Permissions } from 'expo';

/* tslint:disable:no-empty */
/* tslint:disable:max-line-length */

const friendNamespace = 'friendState';
const userNamespace = 'userState';
const violationNamespace = 'violationState';

@Component({
  components: {UserMarker},
})
export default class Map extends mixins(GoogleMapsLoader, CurrentLocation) {
    @Prop(String) public readonly selectedFriend!: string;
    @Prop() public readonly nearbyFriends!: MAFUser[] | [];
    @State('self', {namespace: userNamespace}) public self: MAFUser | undefined;
    @State('friends', {namespace: friendNamespace}) public friends!: MAFUser[] | [];
    @State('allUsers', {namespace: violationNamespace}) public allUsers!: MAFUser[];
    @Action('setUserLocation', {namespace: userNamespace}) public setUserLocation!: any;

    @Provide('gMap') public gMap: any = this.getMap;

    public pos: GeoPoint | null;
    public zoomed: boolean = false;
    public filterMe: boolean = true; // IF TRUE - this means to include user in the data (NOT filter user out)
    public filterUser: boolean = true;
    public filterAdmin: boolean = true;
    public filterCaregiver: boolean = true;
    public filterOrganization: boolean = true;
    public filterMale: boolean = true;
    public filterFemale: boolean = true;
    public minAge: number = 0;
    public maxAge: number = 100;
    public legendOpened: boolean = false;
    public openPopup: boolean = false;

    constructor() {
      super();
      this.pos = null;
    }
    public age(date: any) {
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!date) {
            return 0;
        }
        if (typeof date === 'string') {
            birthday = DateTime.fromISO(date);
        } else if (date instanceof Date) {
            birthday = DateTime.fromJSDate(date);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return diffInYears;
    }
    public getUsers(vm: any) {
      // let usersFiltered: MAFUser[] = [];
      const caregiverTypes = ['Parent/Caregiver', 'A Caregiver', 'My Parents'];
      const generalUserTypes = ['General User', 'Me and a Caregiver', 'Me and Parents'];

      if (!this.filterMe && !this.filterUser && !this.filterAdmin && !this.filterCaregiver && !this.filterOrganization) {
        // all filters are toggled off, reverse them to all be toggled on
        this.filterMe = !this.filterMe;
        this.filterAdmin = !this.filterAdmin;
        this.filterCaregiver = !this.filterCaregiver;
        this.filterOrganization = !this.filterOrganization;
        this.filterUser = !this.filterUser;
      }

      const usersFiltered: MAFUser[] = [...this.nearbyFriends]; // copy of nearby friends
      return usersFiltered.filter((user) =>
        ((this.filterAdmin === user.isAdmin) ||
        (this.filterCaregiver && user.userType && caregiverTypes.includes(user.userType)) ||
        (this.filterOrganization && user.userType === 'Organization') ||
        (this.filterUser && user.userType && generalUserTypes.includes(user.userType))) &&
        (vm.age(user.birthdate) <= this.maxAge && user.userType && vm.age(user.birthdate) >= this.minAge) &&
        ((this.filterMale && !this.filterFemale && user.gender !== 'female') ||
        (this.filterFemale && !this.filterMale && user.gender !== 'male') ||
        (this.filterFemale && this.filterMale) ||
        (!this.filterMale && !this.filterFemale && (!user.gender || user.gender !== 'male' && user.gender !== 'female') )
        ),
      );
    }
    public changeFilter(userType: string) {
      switch (userType) {
        case 'me':
          this.filterMe = !this.filterMe;
          break;
        case 'admin':
          this.filterAdmin = !this.filterAdmin;
          break;
        case 'user':
          this.filterUser = !this.filterUser;
          break;
        case 'caregiver':
          this.filterCaregiver = !this.filterCaregiver;
          break;
        case 'organization':
          this.filterOrganization = !this.filterOrganization;
      }
    }
    public closeLegend() {
      this.legendOpened = !this.legendOpened;
    }

    @Watch('selectedFriend')
    public onSelectedFriendChange() {}

    @Watch('googleMap')
    public mapsLoaded() {
      if (this.googleMap) {
        if (this.$refs.mapDiv ) {
          this.map = new this.googleMap.maps.Map(this.$refs.mapDiv instanceof Element ? this.$refs.mapDiv : null, {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            center: {lat: 39.828175, lng: -98.5795},
            zoom: 5,
            styles: [
              {
                featureType: 'administrative',
                elementType: 'geometry',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'administrative.land_parcel',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'poi',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'poi',
                elementType: 'labels.text',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'road.arterial',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'road.highway',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'road.local',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'road.local',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'transit',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
            ],
          });
        }
        if (this.currentLocation && this.map) {
          this.map.panTo(
            new google.maps.LatLng(
              this.currentLocation.coords.latitude,
              this.currentLocation.coords.longitude,
            ),
          );
          this.map.setZoom(10);
        }

        const legend = document.getElementById('legend');
        if (this.map && legend) {
          this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
        }
      }
    }

    public getMap(found: any): MarkerInjectable | any {
      const vm = this;
      function checkForMap() {
        if (vm.map && vm.currentLocation) {
          found({ map: vm.map, googleMap: vm.googleMap, position: vm.currentLocation });
        } else {
          setTimeout(checkForMap, 50);
        }
      }
      checkForMap();
    }

    @Watch('currentLocation')
    public currentLocationAquired() {
      if (this.currentLocation && this.map) {
        this.map.panTo(
          new google.maps.LatLng(
            this.currentLocation.coords.latitude,
            this.currentLocation.coords.longitude,
          ),
        );
        this.map.setZoom(10);
        this.setUserLocation(this.currentLocation);
      }
      if (this.currentLocation) {
        this.pos = new GeoPoint(this.currentLocation.coords.latitude, this.currentLocation.coords.longitude);
      }
    }

    @Watch('nearbyFriends')
    public zoomToFriends() {
      if (this.self && this.map && this.self.isAdmin) {
        // zoom to fit most of US
        this.map.setZoom(4);
      } else {
        if (this.nearbyFriends && this.nearbyFriends.length > 0 && this.map && this.googleMap && !this.zoomed) {
          const bounds = new this.googleMap.maps.LatLngBounds();

          if (this.selectedFriend) {
            // force trigger friend info popup
            this.openPopup = true;
          }

          if (this.self && this.self.location) {
            bounds.extend(
              new this.googleMap.maps.LatLng(
                this.self.location.latitude,
                this.self.location.longitude,
              ),
            );
          }
          this.nearbyFriends.forEach((friend: MAFUser) => {
            if (friend.location && this.googleMap) {
              bounds.extend(new this.googleMap.maps.LatLng(friend.location.latitude, friend.location.longitude));
            }
          });
          this.map.fitBounds(bounds);
          this.zoomed = true;
        } else if (this.nearbyFriends && this.nearbyFriends.length === 0) {
          this.zoomed = false;
        }
      }
    }

}
